import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n";

export default function PaymentCancel() {
  const { lang } = useLang();
  return (
    <div className="min-h-screen grid place-items-center bg-[#0c0d10] px-6 text-center">
      <div className="max-w-md">
        <XCircle size={56} className="text-[#F59E0B] mx-auto" />
        <h1 className="mt-4 font-heading text-3xl font-black uppercase text-white">
          {lang === "it" ? "Pagamento annullato" : "Payment cancelled"}
        </h1>
        <p className="mt-2 text-zinc-400">
          {lang === "it" ? "Nessun addebito effettuato." : "No charge was made."}
        </p>
        <Link
          to="/blueprint"
          data-testid="back-to-blueprint-btn"
          className="mt-6 inline-block px-8 py-3 bg-[#E63946] hover:bg-[#D90429] text-white font-bold uppercase rounded-md"
        >
          {lang === "it" ? "Torna al Blueprint" : "Back to Blueprint"}
        </Link>
      </div>
    </div>
  );
}
